interface EditIconProps {
  className?: string;
}

const EditIcon: React.FC<EditIconProps> = (props) => {
  return (
    <svg
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M10.8536 5.09619L8.73223 2.97487L10.1464 1.56066C10.3417 1.3654 10.6583 1.3654 10.8536 1.56066L12.2678 2.97487C12.463 3.17014 12.463 3.48672 12.2678 3.68198L10.8536 5.09619ZM10.1464 5.8033L3.36827 12.5815C3.2745 12.6752 3.14733 12.7279 3.01472 12.7279L1.6005 12.7279C1.32436 12.7279 1.10051 12.5041 1.10051 12.2279L1.10051 10.8137C1.10051 10.6811 1.15318 10.5539 1.24695 10.4602L8.02513 3.68198L10.1464 5.8033Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export default EditIcon;
